/**
 * Compara versiones por segmentos numéricos.
 *
 * Soporta CalVer (YYYY.MM.DD.N), SemVer (1.2.3) y variantes con pre-release
 * / build metadata (1.2.3-rc.1+build.5): los separadores no numéricos se
 * ignoran y cada segmento se compara como entero. Los segmentos faltantes se
 * tratan como 0 (1.2 == 1.2.0).
 *
 * @returns -1 si `a` < `b`, 0 si son iguales, 1 si `a` > `b`.
 */
export function compareVersions(a: string, b: string): number {
  const pa = (a || '0').split(/[.+-]/).map((n) => parseInt(n, 10) || 0);
  const pb = (b || '0').split(/[.+-]/).map((n) => parseInt(n, 10) || 0);
  const max = Math.max(pa.length, pb.length);
  for (let i = 0; i < max; i++) {
    const va = pa[i] ?? 0;
    const vb = pb[i] ?? 0;
    if (va > vb) return 1;
    if (va < vb) return -1;
  }
  return 0;
}

/**
 * `true` cuando `current` está estrictamente por debajo de `latest`.
 * Devuelve `false` si falta alguna de las dos versiones (no podemos afirmar).
 */
export function isOutdatedVersion(
  current: string | undefined,
  latest: string | undefined
): boolean {
  if (!current || !latest) return false;
  return compareVersions(current, latest) < 0;
}
